<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                        :label="$t('previsionnelDepart.filtre.type')"
                        :items="constantes.LISTE_TYPE_DEVIS_COMMANDE"
                        v-model="typesSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('previsionnelDepart.filtre.agences')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesIdProduit">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeFace.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeFace.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { LISTE_TYPE_DEVIS_COMMANDE } from '@/configuration/devisConf';
import { SET_CRITERE_PREVISIONNEL } from '@/store/modules/ligneCommande-mutation-type';
import genererCritereRecherchePrevisionnel
  from '@/services/ligneCommande/genererCritereRecherchePrevisionnel';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const LigneCommande = createNamespacedHelpers('ligneCommande');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: null,
      constantes: {
        LISTE_TYPE_DEVIS_COMMANDE,
      },
      typesSelected: [],
    };
  },
  components: {
    agenceTagInput,
    libelleTagInput,
  },
  computed: {
    ...LigneCommande.mapGetters({
      critereRechercheFromStore: 'criteresRecherchePrevisionnel',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
  },
  methods: {
    ...LigneCommande.mapMutations({
      setCritereRecherche: SET_CRITERE_PREVISIONNEL,
    }),
    appliquerCritere() {
      this.critereRecherche.typesDevisCommandeFacture = this.typesSelected.map(el => {
        return el.code;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.typesSelected = [];
      this.critereRecherche = cloneDeep(genererCritereRecherchePrevisionnel());
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      if (this.critereRecherche.typesDevisCommandeFacture) {
        this.typesSelected = this.constantes.LISTE_TYPE_DEVIS_COMMANDE.filter((c) => {
          return this.critereRecherche.typesDevisCommandeFacture.includes(c.code);
        });
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
